import React, {useState, Fragment, useCallback, useEffect,useReducer} from 'react';
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Row  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { diagnosis, diagnosistableColumns } from '../../../../Data/TreatmentSettings';
import CommonModal from '../../../Common/Component/CommonModal';
import RequiredField, { Category } from '../../../../Constant';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreateDiagnosis, DeleteDiagnosis, DiagnosisList,DiagnosisTypeList, UpdateDiagnosis } from '../../../../apiController';
import { roles_permissions } from '../../../../Layout/Sidebar/Menu';

const initialState = {
  dname: '',
  diagnosis: '',
  id:''
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_DIAGNOSIS_TYPE':
      return { ...state, dname: action.payload };
    case 'SET_DIAGNOSIS':
      return { ...state, diagnosis: action.payload };
    case 'SET_ID':
      return { ...state, id: action.payload };
    case 'RESET_FORM':
      return initialState;
    default:
      return state;
  }
};

const Diagnosis = () =>{

  const [Large, setLarge] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);

  const permission = roles_permissions.find(
    (module) => module.module_name === "Diagnosis"
  );


  const LargeModaltoggle = () =>{ setLarge(!Large); 
    dispatch({ type: 'RESET_FORM'});
  };

  const [formdata, setFormdata] = useState({});
  const [diagnosisCategory, setDiagnosis] = useState([]);
  const [diagnosisTypes, setDiagnosisTypes] = useState([]);


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();


  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

   const diagnosistableColumns = [
    {
        name: '#',
        selector: row => row['ind'],
        sortable: true,
        center: false,
    },
    {
        name: 'Diagnosis Type',
        selector: row => row['diagnosistype'],
        sortable: true,
        center: true,
    },
    {
        name: 'Diagnosis',
        selector: row => row['diagnosis'],
        sortable: true,
        center: true,
    },
    // {
    //     name: 'Action',
    //     selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
    //     sortable: false,
    //     center: true,
    // },
];

if (permission?.edit_access) {
  diagnosistableColumns.push({
    name: "Action",
    selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
    sortable: false,
    center: true,
  });
}

 const diagnosis = diagnosisCategory.map((row, ind)=>
    ({
        ind: ind+1,
        id: row.id,
        diagnosistype: row.dname,
        diagnosis: row.name,
        action: 
        ({ LargeModaltoggle }) => (
            <span>
                <Btn
                    attrBtn={{
                        style:  { width: 60, fontSize: 14, padding: 4 },
                        color: 'success',
                        className: 'btn btn-xs',
                        type: 'button',
                        onClick: () => handleEdit(row)
                    }}
                >
                    Edit
                </Btn>
            </span>
        )
    })
  );

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(diagnosis);
    const handleChange = (e) => {
      const { name, value } = e.target;
      dispatch({ type: `SET_${name.toUpperCase()}`, payload: value });
    };

    const handleEdit = (row) => {
      console.log(row)
      setFormdata({ id: row.id, dname: row.dname , diagnosis: row.name});
      setLarge(!Large);
      dispatch({ type: 'SET_DIAGNOSIS_TYPE', payload: row.diagnosis_type });
    dispatch({ type: 'SET_DIAGNOSIS', payload: row.name });
    dispatch({ type: 'SET_ID', payload: row.id });
    };

    const handleSaveForm = async (formData) => {  

      const formattedData = {
        diagnosis_type: state.dname,
        name:state.diagnosis,
        id: state.id
    };
    console.log(formattedData)

    try {
      if (state.id) {
          const response = await UpdateDiagnosis(formattedData);
          if (response.status === true) {
            // setDiagnosis(prev => prev.map(item => item.id === formdata.id ? { ...item, name: formattedData.name } : item));
              toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
              // setTimeout(() => {
              //   window.location.reload();
              //   }, 2000);

          }
      } else {
          const response = await CreateDiagnosis(formattedData);
          if (response.status === true) {
            setDiagnosis(prev => [...prev, response.data]);
              toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
          }
      }
      fetchDiagnosis();
      LargeModaltoggle();
  } catch (error) {
      toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  }

      
      // reset({diagnosis:'', dname:''})
    };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

  // const handleDelete = () => {
  //   SweetAlert.fire({
  //     title: 'Are you sure you want to do to delete?',
  //     cancelButtonText: 'no!',
  //     confirmButtonText: 'yes!',
  //     reverseButtons: true,
  //     showCancelButton: true,
  // })
  // setToggleDelet(!toggleDelet)
  // setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
  // setSelectedRows([]);

  
      
  //     toast.error('Danger Notification !', {
  //       position: toast.POSITION.TOP_CENTER
  //     })
  // };

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: 'Are you sure you want to delete?',
      cancelButtonText: 'No!',
      confirmButtonText: 'Yes!',
      reverseButtons: true,
      showCancelButton: true,
    });
  
    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map(row => row.id); 
        await Promise.all(selectedIds.map(id => DeleteDiagnosis(id)));
        setDiagnosisTypes(diagnosisTypes.filter(item => !selectedIds.includes(item.id)));
        setSelectedRows([]);
        toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
        fetchDiagnosis()
      } catch (error) {
        toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
      }
    }
  };


  const fetchDiagnosis = async () => {
    const response = await DiagnosisList();
    if (response.status === true) {
      setDiagnosis(response.data);
    }
  };

  const fetchDiagnosisType = async () => {
    const response = await DiagnosisTypeList();
    if (response.status === true) {
      setDiagnosisTypes(response.data);
    }
  };

  useEffect(()=>{
    fetchDiagnosis()
    fetchDiagnosisType()
  },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Diagnosis' parent='Dashboard' title='diagnosis' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className='card-header-right-icon'>
            {permission?.create_access &&  <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary',  onClick: LargeModaltoggle }}>+ Add Diagnosis</Btn>}
            <CommonModal isOpen={Large} title={"Diagnosis"} toggler={LargeModaltoggle} size="lg" onSave={handleSaveForm} formdata={formdata}>
              <Row className='d-flex gap-5'>
                <Col sm="12">
                <FormGroup className="mb-3">
                                    <Label htmlFor="exampleFormControlSelect9">{Category} <RequiredField/></Label>
                                    <Input type="select" name="DIAGNOSIS_TYPE" className="form-control digits" id="dname"  value={state.dname} onChange={handleChange} >
                                    <option  value=''>Select Diagnosis Type</option>
                                 
                                    {diagnosisTypes.map((type)=> <option key={type.id} value={type.id}>{type.name}</option>
                                    )}
                                     </Input>
                                        {/* defaultValue={formdata.dname || ""} {...register("dname", { required: true })} */}
                                    {/* defaultValue={formdata.diagnosis || ""} {...register("diagnosis", { required: true })} */}
                                    {/* <select name="dname" className="form-control digits" id="dname" name='DIAGNOSIS_TYPE' value={state.dname} onChange={handleChange}>
                                    <option value="">Select Diagnosis Type</option>
    {diagnosisTypes.map((type) => (
        <option key={type.id} value={type.id}>{type.name}</option>
    ))}
</select> */}
                                        {/* <option>{'Oral Dentistry'}</option>
                                        <option>{'Oral Implantology'}</option>
                                        <option>{'General Dentistry'}</option>
                                        <option>{'Community Dentistry'}</option>
                                        <option>{'Oral Medicine Radiology'}</option> */}
                                   
                                    <span className="text-danger">{errors.diagnosistype && "Diagnosis type is required"}</span>
                                </FormGroup>
            
            </Col>
            <Col sm="12">
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Diagnosis"} <RequiredField/></Label>
              <input className={`form-control ${errors.diagnosis && "is-invalid"}`} id="diagnosis" type="text" name="diagnosis" value={state.diagnosis} onChange={handleChange}/>
              <span className="text-danger">{errors.diagnosis && "Diagnosis is required"}</span>
            </FormGroup>
            </Col>
            </Row>
            </CommonModal>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={diagnosis}
                columns={diagnosistableColumns}
                striped={true}
                center={true}
                pagination
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default Diagnosis